export default __webpack_public_path__ + "static/media/_calculator_roas_dark.949af185.svg";